import gql from 'graphql-tag';

// Dynamic mutation function that returns the appropriate mutation based on whether justification is provided
export const getWriteOutlierExceptionMutation = (hasJustification: boolean) => {
  if (hasJustification) {
    return gql`
      mutation WriteOutlierException(
        $userId: String!
        $deliveredToUsername: String!
        $deliveredToUserId: String!
        $contactId: String!
        $outlierCalYear: String!
        $outlierCalWeek: String!
        $justification: String!
      ) {
        writeOutlierException(
          userId: $userId
          deliveredToUsername: $deliveredToUsername
          deliveredToUserId: $deliveredToUserId
          contactId: $contactId
          outlierCalYear: $outlierCalYear
          outlierCalWeek: $outlierCalWeek
          justification: $justification
        )
      }
    `;
  } else {
    return gql`
      mutation WriteOutlierException(
        $userId: String!
        $deliveredToUsername: String!
        $deliveredToUserId: String!
        $contactId: String!
        $outlierCalYear: String!
        $outlierCalWeek: String!
      ) {
        writeOutlierException(
          userId: $userId
          deliveredToUsername: $deliveredToUsername
          deliveredToUserId: $deliveredToUserId
          contactId: $contactId
          outlierCalYear: $outlierCalYear
          outlierCalWeek: $outlierCalWeek
        )
      }
    `;
  }
};

// Keep the original export for backward compatibility (defaults to no justification)
export const writeOutlierException = getWriteOutlierExceptionMutation(false);

export const updateOutlierException = gql`
  mutation UpdateOutlierException(
    $userId: String!
    $deliveredToUsername: String!
    $contactId: String!
    $exceptionStatus: ExceptionStatus!
    $outlierCalYear: String!
  ) {
    updateOutlierException(
      userId: $userId
      deliveredToUsername: $deliveredToUsername
      contactId: $contactId
      exceptionStatus: $exceptionStatus
      outlierCalYear: $outlierCalYear
    )
  }
`;
